export class UserLobbySettingsModel {
    UserId: number = 0;
    DefaultLobbyTab?: string;
    DefaultCentralView?: string;
    ShowInLobby: boolean = false;
    ShowInKiosk: boolean = false;
    SupervisorId?: number;
    IsSupervisor: boolean = false;
    EnableUserImpersonation: boolean = false;
    ShowUserForImpersonation: boolean = false;
}
